import { Button, ModalV2 } from '@skand/ui';

export interface RemoveCalculationModalProps {
  open: boolean;
  onSubmit: () => void;
  onCancel: () => void;
  shapeType?: string;
}

export const RemoveCalculationModal = ({
  open,
  shapeType,
  onCancel,
  onSubmit,
}: RemoveCalculationModalProps) => {
  return (
    <ModalV2 open={open}>
      <div className="mt-1 flex flex-col gap-6">
        <p className="color-neutral-800 typo-text-m">{`Remove ${
          shapeType === 'Polygon' ? 'volume calculation' : 'elevation profile'
        }?`}</p>
        <p className="color-neutral-800 typo-text-s">
          {`This will remove the current ${
            shapeType === 'Polygon' ? 'volumetric measurement' : 'elevation profile'
          } . You can recalculate it anytime.`}
        </p>
      </div>
      <div className="mt-4 w-full flex gap-2">
        <Button className="w-full cursor-pointer" onClick={onCancel} size="s">
          Cancel
        </Button>
        <Button className="w-full cursor-pointer" filled onClick={onSubmit} primary size="s">
          Remove {shapeType === 'Polygon' ? 'Volume' : 'Profile'}
        </Button>
      </div>
    </ModalV2>
  );
};
